import { useLocale } from 'next-intl';
import { forwardRef } from 'react';
import styles from './TrustpilotWidget.module.css';
import type { WidgetProps } from './TrustpilotWidget.types';

const MicroCombo = forwardRef<HTMLDivElement, WidgetProps>(({ children }, ref) => {
  const locale = useLocale();
  return (
    <div className={styles.microcombo}>
      <div
        ref={ref}
        className="trustpilot-widget"
        aria-hidden="true"
        data-locale={locale}
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="5f561c385c8bbc00013d41f2"
        data-style-height="28px"
        data-style-width="100%"
        data-theme="light"
      >
        {children}
      </div>
    </div>
  );
});

MicroCombo.displayName = 'TrustpilotMicroCombo';

export { MicroCombo };
